import {
  DEFAULT_SERVICES, DEFAULT_REGION,
  STORAGE_KEY_SERVICES, STORAGE_KEY_PREFS, STORAGE_KEY_REGION, STORAGE_KEY_SETUP,
  SERVICES, REGIONS,
} from './constants.js'

// ── Schema constants (built from the authoritative SERVICES / REGIONS arrays) ──
const VALID_SERVICE_IDS  = new Set(SERVICES.map(s => s.id))
const VALID_REGION_CODES = new Set(REGIONS.map(r => r.code))
const VALID_PREF_TYPES   = new Set(['like', 'dislike', 'watched'])
const MAX_PREFS          = 500   // guard against runaway growth

// ── Setup flag ─────────────────────────────────────────────────────────────────
export function loadSetupDone() {
  try {
    if (localStorage.getItem(STORAGE_KEY_SETUP) === 'true') return true
    return !!localStorage.getItem(STORAGE_KEY_SERVICES)
  } catch { return false }
}
export function saveSetupDone() {
  try { localStorage.setItem(STORAGE_KEY_SETUP, 'true') } catch {}
}

// ── Region ─────────────────────────────────────────────────────────────────────
export function loadRegion() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY_REGION)
    if (saved && VALID_REGION_CODES.has(saved)) return saved
    return DEFAULT_REGION
  } catch {
    return DEFAULT_REGION
  }
}

export function saveRegion(code) {
  try { localStorage.setItem(STORAGE_KEY_REGION, code) } catch {}
}

// ── Services ───────────────────────────────────────────────────────────────────
export function loadServices() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY_SERVICES)
    if (!saved) return DEFAULT_SERVICES
    const parsed = JSON.parse(saved)
    if (!Array.isArray(parsed)) return DEFAULT_SERVICES
    const valid = parsed.filter(id => typeof id === 'string' && VALID_SERVICE_IDS.has(id))
    return valid.length ? valid : DEFAULT_SERVICES
  } catch {
    return DEFAULT_SERVICES
  }
}

export function saveServices(services) {
  try { localStorage.setItem(STORAGE_KEY_SERVICES, JSON.stringify(services)) } catch {}
}

// ── User preferences (liked / disliked / watched titles) ───────────────────────
export function loadPrefs() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY_PREFS)
    if (!saved) return []
    const parsed = JSON.parse(saved)
    if (!Array.isArray(parsed)) return []
    return parsed
      .filter(p =>
        p !== null &&
        typeof p === 'object' &&
        typeof p.title === 'string' &&
        p.title.length > 0 &&
        p.title.length <= 300 &&
        VALID_PREF_TYPES.has(p.type)
      )
      .slice(0, MAX_PREFS)
  } catch {
    return []
  }
}

export function savePrefs(prefs) {
  try { localStorage.setItem(STORAGE_KEY_PREFS, JSON.stringify(prefs)) } catch {}
}

export function clearPrefs() {
  try { localStorage.removeItem(STORAGE_KEY_PREFS) } catch {}
}

// ── Visit counter (for PWA prompt after 3+ visits) ─────────────────────────
const STORAGE_KEY_VISITS = 'flow_visit_count'

export function loadVisitCount() {
  try { return parseInt(localStorage.getItem(STORAGE_KEY_VISITS) || '0', 10) || 0 } catch { return 0 }
}

export function incrementVisitCount() {
  try {
    const next = loadVisitCount() + 1
    localStorage.setItem(STORAGE_KEY_VISITS, String(next))
    return next
  } catch { return 0 }
}
